import {XhrService} from "cronus-theme/default/global/ts/xhr.service";
import {addErrorClass} from "cronus-theme/default/global/js/utilities/updateClasses";
import {FetchService} from "dc-services/fetch.service";

export async function loadPrices(wrapper= document){
    for(let target of wrapper.querySelectorAll(".js-loadBeturboPrices")){
        let formData = new FormData();
        formData.set('item_id', parseInt(target.dataset.id));

        XhrService.generalAjaxCall('loadItemListPrices', formData, 'POST', 'json').then(async response => {
            if (!response.status) {
                throw "Could not load prices";
            }
            if (response.html) {
                const html = response.html;
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                const priceSpan = doc.querySelector(".price--actionPrice span:not(.itemDepositCost)");
                if (priceSpan && GLOBALS.priceToFloat(priceSpan.textContent.trim()) === 0) {
                    priceSpan.textContent = GLOBALS.tc.request_price;
                }

                let data = {
                    countryCode : "D",
                    itemNo : target.dataset.itemno,
                };
                let sendData = JSON.stringify(data);

                const fetchResponse = await FetchService.post('/em/depositCost/calculateForItemNo/', sendData);
                if (fetchResponse.success) {
                    const depositCost = fetchResponse.data.depositCost;
                    if(depositCost) {
                        const formatPrice = new Intl.NumberFormat(document.body.dataset.localeCode, {
                            style: 'currency',
                            currency: document.body.dataset.defaultCurrency
                        }).format(depositCost);
                        const depositElement = doc.querySelector(".itemDepositCost");
                        if(depositElement) {
                            depositElement.textContent = "+ " + formatPrice + " " + GLOBALS.tc.deposit_costs;
                        }

                    }
                }

                target.innerHTML = doc.body.innerHTML;
            }
        })
            .catch((e) => {
                addErrorClass(target);
                console.error('Error:', e);
            });
    }
}

export function replaceZeroPrices(wrapper = document) {
    for (const placeholder of wrapper.querySelectorAll('.request_price_placeholder')) {
        placeholder.textContent = GLOBALS.tc.request_price;
    }

    for (const priceSpan of wrapper.querySelectorAll('.price--actionPrice span:not(.itemDepositCost)')) {
        const numericPrice = GLOBALS.priceToFloat(priceSpan.textContent.trim());
        if (numericPrice === 0) {
            priceSpan.textContent = GLOBALS.tc.request_price;
        }
    }

    for (const item of wrapper.querySelectorAll('.directOrderItemlistItem[data-id]')) {
        if (parseFloat(item.dataset.price) === 0) {
            const priceEl = item.querySelector('.js-include-prices');
            if (priceEl) {
                const depositSpan = priceEl.querySelector('.directOrderDepositCosts');
                priceEl.innerHTML = GLOBALS.tc.request_price + (depositSpan ? depositSpan.outerHTML : '<span class="directOrderDepositCosts"></span>');
            }
        }
    }

    for (const item of wrapper.querySelectorAll('.itemBasketBox[data-id]')) {
        if (parseFloat(item.dataset.itemprice) === 0) {
            const priceEl = item.querySelector('.itemBasketBox__price');
            if (priceEl) {
                const depositSpan = priceEl.querySelector('.basketDepositCosts');
                priceEl.innerHTML = GLOBALS.tc.request_price + (depositSpan ? ' ' + depositSpan.outerHTML : ' <span class="basketDepositCosts"></span>');
            }
        }
    }

    for (const item of wrapper.querySelectorAll('.orderItem[data-id]')) {
        if (parseFloat(item.dataset.price) === 0) {
            const basePriceEl = item.querySelector('.orderItem__price .basePrice');
            if (basePriceEl) {
                basePriceEl.textContent = GLOBALS.tc.request_price;
            }
        }
    }

    for (const el of wrapper.querySelectorAll('.orderboxSummary .amountLine__value:not(.loadSkeleton)')) {
        if (el.closest('#basketTax')) continue;
        if (GLOBALS.priceToFloat(el.textContent.trim()) === 0) {
            el.textContent = GLOBALS.tc.request_price;
        }
    }
}